import { useEffect, useState } from "react";
import { MessageCircle, Menu, X } from "lucide-react";
import { waLink, DEFAULT_WA_MESSAGE, PHONE_DISPLAY, PHONE_TEL } from "../data/content";
import { LogoMark } from "./Logo";

const NAV_LINKS = [
  { href: "#inicio", label: "Início", testid: "nav-link-inicio" },
  { href: "#servicos", label: "Serviços", testid: "nav-link-servicos" },
  { href: "#precos", label: "Preços", testid: "nav-link-precos" },
  { href: "#simulador", label: "Simulador", testid: "nav-link-simulador" },
  { href: "#galeria", label: "Galeria", testid: "nav-link-galeria" },
  { href: "#avaliacoes", label: "Avaliações", testid: "nav-link-avaliacoes" },
  { href: "#contactos", label: "Contactos", testid: "nav-link-contactos" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0A1128]/85 backdrop-blur-xl border-b border-white/10 shadow-lg shadow-black/30"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <a href="#inicio" data-testid="nav-logo" className="flex items-center gap-3">
            <LogoMark size="sm" />
            <div className="leading-tight">
              <span className="font-display font-extrabold text-white tracking-tight text-sm sm:text-base block">
                EFEITO <span className="text-sky-400">NOVO</span>
              </span>
              <span className="text-[10px] sm:text-[11px] text-slate-400 tracking-widest uppercase">
                Limpeza Profissional
              </span>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-6" data-testid="nav-links">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={link.testid}
                className="text-sm font-medium text-slate-300 hover:text-sky-300 transition-colors"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <a
              href={PHONE_TEL}
              data-testid="nav-phone-link"
              className="text-sm font-semibold text-slate-200 hover:text-sky-300 transition-colors"
            >
              {PHONE_DISPLAY}
            </a>
            <a
              href={waLink(DEFAULT_WA_MESSAGE)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-quote-button"
              className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1eb857] text-[#06281a] font-bold text-sm px-5 py-2.5 rounded-full transition-colors shadow-lg shadow-[#25D366]/25"
            >
              <MessageCircle className="h-4 w-4" />
              Pedir Orçamento
            </a>
          </div>

          <button
            data-testid="nav-mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2"
            aria-label="Abrir menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden bg-[#0A1128]/95 backdrop-blur-xl border-b border-white/10 px-4 pb-6 pt-2 space-y-1"
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`${link.testid}-mobile`}
              onClick={() => setOpen(false)}
              className="block py-3 text-base font-medium text-slate-200 hover:text-sky-300 border-b border-white/5"
            >
              {link.label}
            </a>
          ))}
          <a
            href={waLink(DEFAULT_WA_MESSAGE)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-quote-button-mobile"
            className="mt-4 flex items-center justify-center gap-2 bg-[#25D366] text-[#06281a] font-bold px-5 py-3.5 rounded-full"
          >
            <MessageCircle className="h-5 w-5" />
            Pedir Orçamento no WhatsApp
          </a>
        </div>
      )}
    </header>
  );
};
